import angular from 'angular';
import template from './template.jade';
import './styles.styl';

export default angular
	.module('ui.cian.preloader', [])
	.directive('cianUiPreloader', () => ({
		scope: {},
		bindToController: {
			speed: '=?',
			size: '=?',
			muted: '='
		},
		controller: ['$element', function ($element) {
			// find() - Limited to lookups by tag name
			// so we use native querySelector instead
			const circle = $element[0].querySelector('.cui-preloader__circle');
			const $circle = angular.element(circle);

			this.speed = this.speed || 5;
			this.size = this.size || 50;

			$circle.css({
				width: `${this.size}px`,
				height: `${this.size}px`,
				animationDuration: `${(this.speed / 5)}s`
			});
		}],
		controllerAs: 'preloader',
		transclude: true,
		replace: true,
		template,
	}))
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/components/preloader/index.jsm